import { fieldStyle } from '../../dashboards/primitives';
import { Field } from '../../dashboards/primitives/Field';

import { NOTE, requiredProps } from './step-layout';
import type { LocationFormApi } from './when-what-form-api';

function placeholder(form: LocationFormApi, empty: boolean): string {
  if (!form.fields.regionId) return 'Choose a region first';
  if (form.venuesStatus === 'loading') return 'Loading venues…';
  if (form.venuesStatus === 'failed') return 'Couldn’t load venues';
  return empty ? 'No active venues' : 'Select a venue…';
}

/** The partner-venue branch: active venues in the chosen region. An empty
 *  region and a failed load are different facts and read differently. */
export default function VenueSelectField({ form }: { form: LocationFormApi }) {
  const { fields, set, venueOptions, venuesStatus, fieldError, retryVenues } = form;
  const error = fieldError('venueId');
  const failed = venuesStatus === 'failed';
  const empty = Boolean(fields.regionId) && venuesStatus === 'ready' && venueOptions.length === 0;
  return (
    <>
      <Field label="Venue" required error={error}>
        <select
          aria-label="Venue"
          {...requiredProps(error)}
          disabled={!fields.regionId || venuesStatus !== 'ready' || empty}
          value={fields.venueId}
          onChange={(e) => set('venueId', e.target.value)}
          style={fieldStyle(error ? 'error' : undefined)}
        >
          <option value="">{placeholder(form, empty)}</option>
          {venueOptions.map((v) => (
            <option key={v.id} value={v.id}>
              {v.name}
            </option>
          ))}
        </select>
      </Field>
      {failed && (
        <p role="alert" style={{ ...NOTE, color: 'var(--nb-risk)' }}>
          We couldn’t load venues.{' '}
          <button
            type="button"
            onClick={retryVenues}
            style={{ color: 'var(--nb-primary)', fontWeight: 700, textDecoration: 'underline' }}
          >
            Retry
          </button>{' '}
          or choose Client address or To be determined.
        </p>
      )}
      {empty && (
        <p style={NOTE}>
          No active venues in this region. Choose Client address or To be determined instead.
        </p>
      )}
    </>
  );
}
